import React from 'react';

import { createComponent, Layout, enums, Header, Label, Button, Icon } from 'console-kit';
import { connect } from 'react-redux';

import authStatics from '../../../../common/static';
import AuthImageLogo from '../../../../components/AuthImageLogo';

import AuthPanelSelectors from '../../redux/selectors';
import _enums from 'console/Auth/app/common/enums';

import AuthPanelActions from '../../redux/actions';

const noPadding = { padding: 0 };
const sectionPaddingBottom = { paddingBottom: '16px' };
const sectionPaddingTop = { paddingTop: '16px' };
const subSectionPadding = { paddingTop: '8px', paddingBottom: '24px' };
const iconPadding = { paddingRight: '8px' };

const AuthPanelCESUpgradeMessage = createComponent({
  displayName: 'AuthPanelCESUpgradeMessage',

  render(props) {
    const _showSkipSection = props.skipCountdown && props.loginType === _enums.loginTypes.CESSSO_INVITED_TYPE;
    const _daysToSkip = `${props.skipCountdown} day${props.skipCountdown !== 1 ? 's' : ''}`;

    return (
      <div className={authStatics.SCREEN_CLASSES}>
        <form ref={props.setAuthPanelRef} action={authStatics.AUTH_FORM_SUBMIT_URL}>
          <input type="hidden" name={props.rememberMeFieldName} value={!!props.rememberMeFieldValue} />
          <Layout>
            <Layout.Row>
              <Layout.Column textAlign={enums.textAlignments.CENTER}>
                <AuthImageLogo />
              </Layout.Column>
            </Layout.Row>

            <Layout.Row style={sectionPaddingTop}>
              <Layout.Column textAlign={enums.textAlignments.LEFT}>
                <Header
                  text="You've been upgraded"
                  isDividing={false}
                  font={{ emphasis: enums.font.emphasis.NORMAL }}
                  size={enums.sizes.X6}
                />
              </Layout.Column>
            </Layout.Row>

            <Layout.Row>
              <Layout.Column textAlign={enums.textAlignments.LEFT}>
                <Label
                  text={
                    <span>
                      Your organization has upgraded to <b>Zeta Login</b>. You will have access to your full history for
                      all CES applications using your new Zeta Login.
                    </span>
                  }
                  hasPadding={false}
                  isFluid
                />
              </Layout.Column>
            </Layout.Row>

            <If condition={props.loginType === _enums.loginTypes.CESSSO_INVITED_TYPE}>
              <React.Fragment>
                <Layout.Row>
                  <Layout.Column textAlign={enums.textAlignments.LEFT}>
                    <Label
                      text="Zeta Login setup already? Go to login:"
                      hasPadding={false}
                      isFluid
                      icon={<Icon size={enums.sizes.X6} name={enums.icons.ROCKET} isCompact style={iconPadding} />}
                      font={{ weight: enums.font.weights.MEDIUM }}
                    />
                  </Layout.Column>
                </Layout.Row>
                <Layout.Row borders={enums.directions.H} style={subSectionPadding}>
                  <Layout.Column textAlign={enums.textAlignments.CENTER}>
                    <Button.Primary
                      text="Zeta Login"
                      size={enums.sizes.X4}
                      value={props.cesAuthLoginUrl}
                      onClick={props.onOpenCheetahIdLogin}
                      textAlign={enums.textAlignments.CENTER}
                      color={enums.colors.ACCENT}
                      isSolid
                      isFluid
                    />
                  </Layout.Column>
                </Layout.Row>
              </React.Fragment>
            </If>

            <Layout.Row>
              <Layout.Column textAlign={enums.textAlignments.LEFT}>
                <Label
                  text="Zeta Login not setup yet?"
                  hasPadding={false}
                  isFluid
                  icon={<Icon size={enums.sizes.X5} name={enums.icons.COUNTDOWN} isCompact style={iconPadding} />}
                  font={{ weight: enums.font.weights.MEDIUM }}
                />
              </Layout.Column>
            </Layout.Row>
            <Layout.Row style={noPadding}>
              <Layout.Column textAlign={enums.textAlignments.LEFT}>
                <Label
                  text="You can create your new Zeta Login profile by following the instructions in the email we sent to:"
                  hasPadding={false}
                  isFluid
                />
              </Layout.Column>
            </Layout.Row>

            <Layout.Row
              borders={!_showSkipSection ? enums.directions.H : null}
              style={_showSkipSection ? noPadding : { ...noPadding, ...sectionPaddingBottom }}
            >
              <Layout.Column textAlign={enums.textAlignments.LEFT}>
                <Label text={props.userFieldValue} hasPadding={false} isFluid />
              </Layout.Column>
            </Layout.Row>

            <If condition={_showSkipSection}>
              <Layout.Row style={noPadding}>
                <Layout.Column textAlign={enums.textAlignments.LEFT}>
                  <Label
                    text={
                      <span>
                        You can skip now if you need to log in, but your Zeta Login profile must be created within{' '}
                        <b>{_daysToSkip}</b>.
                      </span>
                    }
                    hasPadding={false}
                    isFluid
                  />
                </Layout.Column>
              </Layout.Row>
              <Layout.Row borders={enums.directions.H} style={{ ...sectionPaddingBottom, ...sectionPaddingTop }}>
                <Layout.Column textAlign={enums.textAlignments.LEFT}>
                  <Label
                    text="Skip for now"
                    value={props.secondaryLoginType}
                    onClick={props.onSkipCesMigration}
                    size={enums.sizes.X4}
                    color={enums.colors.ACCENT}
                    font={{
                      weight:   enums.font.weights.MEDIUM,
                      emphasis: enums.font.emphasis.CAPS,
                    }}
                    style={{ ...noPadding }}
                  />
                </Layout.Column>
              </Layout.Row>
            </If>

            <Layout.Row style={sectionPaddingTop}>
              <Layout.Column textAlign={enums.textAlignments.LEFT}>
                <Label
                  text="Zeta Support"
                  hasPadding={false}
                  icon={<Icon size={enums.sizes.X5} name={enums.icons.HELP_STRONG} isCompact style={iconPadding} />}
                  isFluid
                  font={{ weight: enums.font.weights.MEDIUM }}
                />
              </Layout.Column>
            </Layout.Row>

            <Layout.Row style={noPadding}>
              <Layout.Column textAlign={enums.textAlignments.LEFT}>
                <Label text="Email not received or any other queries, please click below:" hasPadding={false} isFluid />
              </Layout.Column>
            </Layout.Row>

            <Layout.Column textAlign={enums.textAlignments.CENTER}>
              <Button.Primary
                text="Go to Zeta Login Support"
                size={enums.sizes.X4}
                value={props.cesSupportUrl}
                onClick={props.onOpenCheetahIdSupport}
                textAlign={enums.textAlignments.CENTER}
                color={enums.colors.ACCENT}
                isSolid
                isFluid
              />
            </Layout.Column>
          </Layout>
        </form>
      </div>
    );
  },
});

export default connect(
  (state) => ({
    userFieldValue:     AuthPanelSelectors.userFieldValue(state),
    skipCountdown:      AuthPanelSelectors.skipCountdown(state),
    loginType:          AuthPanelSelectors.loginType(state),
    secondaryLoginType: AuthPanelSelectors.secondaryLoginType(state),
    cesSupportUrl:      AuthPanelSelectors.cesSupportUrl(state),
    cesAuthLoginUrl:    AuthPanelSelectors.cesAuthLoginUrl(state),
  }),
  (dispatch) => ({
    onSkipCesMigration: (e, { value }) => {
      dispatch(AuthPanelActions.updateField('loginType', value));
    },
    onOpenCheetahIdSupport: (e, { value }) => {
      e.preventDefault(); // prevent form submit
      window.open(value, '_blank');
    },
    onOpenCheetahIdLogin: (e, { value }) => {
      e.preventDefault(); // prevent form submit
      window.open(value);
    },
  })
)(AuthPanelCESUpgradeMessage);
